/* Translate only displayed text in the existing forms. Field names, submitted
   option values, validation, styling and service connections remain unchanged. */
(() => {
  if (document.documentElement.lang !== 'en') return;
  const copy = new Map(Object.entries({
    'Voornaam': 'First name', 'Achternaam': 'Last name',
    'Je voornaam': 'Your first name', 'Je achternaam': 'Your last name',
    'Je e-mailadres': 'Your email address', 'Je telefoonnummer': 'Your phone number',
    'e-mailadres': 'Email address', 'E-mailadres': 'Email address',
    'Telefoonnummer': 'Phone number', 'Waar gaat je vraag over?': 'What is your question about?',
    'Advies over een model': 'Advice on a model', 'Bestelling of levering': 'Order or delivery',
    'Samenwerking': 'Collaboration', 'Iets anders': 'Something else', 'Je bericht': 'Your message',
    'Ik beweeg, ik ben geen robot.': 'I move; I’m not a robot.',
    'Stuur mijn bericht': 'Send my message', 'Houd me op de hoogte': 'Keep me updated',
    'Houd mij op de hoogte': 'Keep me updated',
    'We hebben je vraag ontvangen. Je hoort zo snel mogelijk van ons.': 'We have received your question. We will get back to you as soon as possible.',
    'Blijf in beweging.': 'Keep moving.',
    'Volg de nieuwste inzichten en ontwikkelingen van Sit-i.': 'Follow the latest insights and developments from Sit-i.',
    'Met je aanmelding geef je Sit-i toestemming om je per e-mail op de hoogte te houden. Je kunt je op ieder moment uitschrijven. Lees in ons': 'By signing up, you give Sit-i permission to keep you updated by email. You can unsubscribe at any time. Read our',
    'Een vraag over Sit-i?': 'A question about Sit-i?',
    'Heb je een vraag over Sit-i of over een toepassing in training, zorg of werk? Stuur ons een bericht. We denken graag met je mee.': 'Do you have a question about Sit-i or its use in training, healthcare or work? Send us a message. We are happy to help you explore the options.',
    'Ik beweeg, ik ben geen robot': 'I move; I’m not a robot',
    'jouw toepassing': 'your application',
    'Schrijf je in voor Sit-i Nieuwsbrief': 'Subscribe to the Sit-i newsletter',
    'We gebruiken je gegevens alleen om je vraag te beantwoorden. Lees in ons': 'We use your details only to answer your question. Read our',
    'privacybeleid': 'privacy policy', 'hoe we met je gegevens omgaan.': 'to find out how we handle your details.',
    'Dit veld is verplicht.': 'This field is required.', 'Maak a.u.b. een keuze': 'Please select an option.',
    'Voer een geldig e-mailadres in.': 'Please enter a valid email address.',
    'Voer een geldig telefoonnummer in.': 'Please enter a valid phone number.',
    'Voer een geldige datum in.': 'Please enter a valid date.',
    'Vink dit vakje aan om verder te gaan': 'Please tick this box to continue.',
    'Formulieren moeten een e-mailveld of een telefoonveld bevatten': 'Forms must include an email field or a phone field.',
    'Sorry, je inzending is mislukt. Probeer het opnieuw.': 'Your submission failed. Please try again.',
    'Sorry, je inzending is mislukt. Kort je antwoorden en probeer het opnieuw.': 'Your submission failed. Please shorten your answers and try again.',
    'Voorkeuren beheren': 'Manage preferences'
  }));
  const translate = value => {
    const trimmed = value.replace(/\s+/g, ' ').trim();
    if (copy.has(trimmed)) return value.replace(value.trim(), copy.get(trimmed));
    const withoutStar = trimmed.replace(/\s*\*$/, '');
    return copy.has(withoutStar) ? copy.get(withoutStar) + ' *' : value;
  };
  const update = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement?.closest('script, style, textarea')
        ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    while (walker.nextNode()) {
      const node = walker.currentNode, translated = translate(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    }
    root.querySelectorAll('[placeholder], [aria-label]').forEach(element => {
      for (const attr of ['placeholder', 'aria-label']) {
        const value = element.getAttribute(attr);
        if (value !== null && translate(value) !== value) element.setAttribute(attr, translate(value));
      }
    });
    root.querySelectorAll('a[href*="sit-i.nl/pages/privacybeleid"]').forEach(link => {
      link.href = '/en/pages/privacy-policy';
    });
  };
  document.querySelectorAll('[data-siti-mailblue], [data-siti-newsletter-form]').forEach(root => {
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; update(root); });
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    update(root);
  });
})();
